import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var ArtCategories = /*#__PURE__*/function () {
  function ArtCategories(context) {
    _classCallCheck(this, ArtCategories);

    this.context = context;
  }

  _createClass(ArtCategories, [{
    key: "getCategories",
    value: function getCategories(params) {
      var url = '/msvc/v1/artcategories/categories';

      if (typeof params === 'object') {
        return this.context.http.get(url, params);
      }

      return this.context.http.get(url, params ? {
        setId: params
      } : null);
    }
  }, {
    key: "getSectors",
    value: function getSectors(params) {
      var url = '/msvc/v1/artcategories/sectornames/names';
      return this.context.http.get(url, params);
    }
  }, {
    key: "getSets",
    value: function getSets() {
      return this.context.http.get('/msvc/v1/artcategories/sets');
    }
  }]);

  return ArtCategories;
}();

export default ArtCategories;